import React from 'react'
import { Paragraph, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { FormCheckbox } from '@fs/zion-form'
import LegalLinks from './LegalLinks'

type Props = {
  isCreating?: boolean
}

/** FamilyGroupTreeLegalTerms is what we show when an existing group adds a shared tree to the group. It was intended to be used in a zionForm.
 */
export default function FamilyGroupTreeLegalTerms({ isCreating }: Props): JSX.Element {
  const [t] = useTranslation()
  return (
    <>
      {!isCreating && <Paragraph size="sm">{t('groups.allow-shared-tree.description')}</Paragraph>}

      <Paragraph size="xs">
        <LegalLinks type="acceptAndPermission" />
      </Paragraph>

      <Separator size="xxs" />

      <FormCheckbox
        data-testid="agree-join-checkbox-tree1"
        name="agreeJoinCheckTree1"
        label={<LegalLinks type="readAndAgree" />}
      />

      <Separator size="nano" />

      <FormCheckbox
        data-testid="agree-join-checkbox-tree2"
        name="agreeJoinCheckTree2"
        label={t('groups.join.right-check')}
      />
    </>
  )
}
